export default function Privacidade() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 py-16 text-slate-300 space-y-6 leading-relaxed">
      <h1 className="font-display text-4xl font-bold text-white">Política de Privacidade</h1>
      <p className="text-sm text-slate-400">Última atualização: {new Date().toLocaleDateString("pt-BR")}</p>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">1. Compromisso com a LGPD</h2>
        <p>O vixvox atua como operador de dados para as empresas contratantes, controladoras dos dados pessoais processados no canal de denúncia, nos termos da Lei 13.709/2018 (LGPD). Todo tratamento é realizado com base nas hipóteses legais previstas nos artigos 7º e 11 da LGPD.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">2. Denúncia anônima</h2>
        <p>No modo anônimo, o sistema não coleta IP, e-mail, cookies de rastreamento ou qualquer metadado técnico correlacionável ao denunciante. A anonimização é técnica e efetiva.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">3. Denúncia identificada</h2>
        <p>Quando o denunciante opta por se identificar, os dados pessoais são armazenados de forma segregada, criptografados em AES-256 e acessíveis apenas por papéis autorizados (tenant admin), com trilha de auditoria imutável.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">4. Controles ISO/IEC 27001</h2>
        <p>Implementamos controles alinhados aos Anexos A.5 (políticas), A.8 (ativos), A.9 (acessos), A.12 (operações seguras) e A.18 (conformidade) da norma ISO 27001:2022.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">5. Retenção e descarte</h2>
        <p>O período de retenção é configurável por cada empresa contratante conforme sua política interna e obrigações legais (mínimo 5 anos para evidências trabalhistas). Ao término, os dados são descartados de forma segura.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">6. Direitos do titular</h2>
        <p>O titular pode exercer os direitos previstos no artigo 18 da LGPD. Para denúncias anônimas, tais direitos ficam naturalmente limitados pela ausência de identificação.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">7. Contato do DPO</h2>
        <p>Encarregado de dados (DPO): dpo@vixvox.com.br</p>
      </section>
    </div>
  );
}
